<div class="market-pairs">
  <div class="custom-heading px-2 d-flex">
    <h5 class="text-color-theme"> {{"history"|translate}}</h5>
    <button type="button" class="btn btn-sm btn-filter" [matMenuTriggerFor]="colMenu">
      <i class="icon ion-md-list"></i></button>
    <mat-menu #colMenu="matMenu" class="mat-menu-panelcolors">
      <div class="menuu">
        <div style="margin: 11px; text-align: start;">
          <strong>{{"aval-cols" | translate}}</strong>
        </div>
        <div cdkDropList (cdkDropListDropped)="drop($event)" style="margin: 4px">
          <div *ngFor="let col of columns" cdkDrag class="card column-dropdown-bg">
            <div class="card-body form-switch d-flex align-items-center justify-content-between" style="padding: 10px; height: 30px;vertical-align: -webkit-baseline-middle ">
              <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggle(col, $event)" [checked]="col.isChecked" class="white-dark-smoke" style="margin: 0px !important;">
                <label [attr.for]="col.name" class="white-dark-smoke" style=" margin: 0px !important;">
                  <mat-icon class="text-muted" style="font-size: 22px;vertical-align: middle ;cursor: grab;">
                    drag_indicator
                  </mat-icon>
                  <span style="font-family: 'Almarai';padding-inline-start: 4px;">{{col.name | translate}}</span>
                </label>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </mat-menu>
  </div>
  <div id="recent-trades" style="overflow:scroll">
    <table id="sortTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table compact nowrap">
      <thead>
        <tr>
          <th class="fit" *ngFor="let item of colsss">{{ item.name | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of orderRequest">
          <td *ngFor="let x of colsss" class="fit">
            <span class="fit" *ngIf="isDate(x.prop)">{{ item[x.prop]| date: 'M/d/yy h:mm a' }}</span>
            <span class="fit" *ngIf="isSymbol(x.prop)">
              <span *ngIf="item.SymbolShortNameEn != null && item.SymbolShortNameAr != null">{{(translate.currentLang == 'en')?item.SymbolShortNameEn:item.SymbolShortNameAr}}</span>
              <span *ngIf="item.SymbolShortNameEn == null && item.SymbolShortNameAr == null">{{(translate.currentLang == 'en')?item.SymbolNameEn:item.SymbolNameAr}}</span>
            </span>
            <span *ngIf="isCustdName(x.name)">{{(translate.currentLang == 'en')?item.CustodianNameEn:item.CustodianNameAr}}</span>
            <span class="fit" *ngIf="isNum(x.prop)">{{ item[x.prop] | number: "1.2-2":"en-US"}}</span>
            <span class="fit" *ngIf="!isDate(x.prop) && !isNum(x.prop) && !isSymbol(x.prop)">{{ item[x.prop]}}</span>
          </td>
        </tr>
        <tr *ngIf="!this.DataToShow">
          <td style="text-align: center !important;" class="no-data-available" colspan="12">{{"no-data-available" |translate}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</div>
